export const getUserDisplayName = (
  firstName?: string | null,
  lastName?: string | null
): string => {
  return [firstName, lastName].filter(Boolean).join(' ').trim();
};
